/**
 * URL Sanitization Utilities for PowerPoint Export
 * Handles encoding of special characters that break PPT XML rendering
 */

/**
 * Sanitize a URL for safe use in PowerPoint XML
 * URLs containing unencoded & characters break the underlying XML in PPTX files
 * causing PowerPoint to report the file as corrupted
 *
 * @param {string} url - URL to sanitize
 * @returns {string} - Sanitized URL safe for PPT XML
 */
export const sanitizeUrlForPPT = url => {
  if (!url) return '';

  // Encode special characters that might break XML
  // But keep the URL functional
  return url
    .replace(/&(?!amp;)/g, '&amp;') // Replace & with &amp; if not already encoded
    .replace(/</g, '%3C') // Encode < to prevent XML injection
    .replace(/>/g, '%3E') // Encode > to prevent XML injection
    .replace(/"/g, '%22') // Encode quotes
    .replace(/'/g, '%27') // Encode single quotes
    .replace(/\s/g, '%20'); // Encode spaces
};
